import React from 'react';
import css from './Sections.module.css';
import Icons from '../../../components/Icons/Icons';
import Slider from 'react-slick';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';
import classNames from 'classnames';
import { SliderSettings } from '../../../util/enums';
import { FormattedMessage } from 'react-intl';

// Local brand images
import adidas from '../../../assets/optimised/adidas.webp';
import mizuno from '../../../assets/optimised/mizuno.webp';
import newbalance from '../../../assets/optimised/newbalance.webp';
import nike from '../../../assets/optimised/nike.webp';
import puma from '../../../assets/optimised/puma.webp';
import skechers from '../../../assets/optimised/skechers.webp';

const brands = [
  {
    id: 'LandingPage.shopNike',
    title: 'Shop Nike',
    image: nike,
    filter: { pub_brandname: 'has_any:nike' },
  },
  {
    id: 'LandingPage.shopAdidas',
    title: 'Shop Adidas',
    image: adidas,
    filter: { pub_brandname: 'has_any:adidas' },
  },
  {
    id: 'LandingPage.shopPuma',
    title: 'Shop Puma',
    image: puma,
    filter: { pub_brandname: 'has_any:puma' },
  },
  {
    id: 'LandingPage.shopSkechers',
    title: 'Shop Skechers',
    image: skechers,
    filter: { pub_brandname: 'has_any:skechers' },
  },
  {
    id: 'LandingPage.shopMizuno',
    title: 'Shop Mizuno',
    image: mizuno,
    filter: { pub_brandname: 'has_any:mizuno' },
  },
  {
    id: 'LandingPage.shopNewBalance',
    title: 'Shop New Balance',
    image: newbalance,
    filter: { pub_brandname: 'has_any:new balance' },
  },
];

const SectionShopByBrands = ({ useHistoryPush, viewport }) => {
  const isMobileLayout = viewport?.width > 0 && viewport?.width < 768;

  return (
    <div className={classNames(css.bannerSec, css.shopByBrandSec)}>
      <div className={css.fixedWidthContainer}>
        <h1 className={css.heading}>
          <FormattedMessage id="LandingPage.shopByModel" />
          <Icons name="rightArrow" />
        </h1>

        <div className={css.contentSec}>
          <Slider
            {...{
              ...SliderSettings,
              dots: isMobileLayout ? false : SliderSettings.dots,
            }}
          >
            {brands.map(({ id, title, image, filter }) => (
              <div
                key={id}
                className={css.bannerBlock}
                role="button"
                tabIndex={0}
                onClick={() => useHistoryPush('SearchPage', filter)}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') useHistoryPush('SearchPage', filter);
                }}
              >
                <div className={css.bannerImg}>
                  <img src={image} alt={title} />
                </div>
                <div className={css.bannerContent}>
                  <h3>
                    <FormattedMessage id={id} defaultMessage={title} />
                  </h3>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default SectionShopByBrands;
